<template>

  <div class="hello">

      <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
          <v-container class="contain-width">
<!--              <v-expand-transition>-->
<!--                  <v-banner two-line v-show="expand" class="white rounded mb-6">-->
<!--                      <v-avatar-->
<!--                              slot="icon"-->
<!--                              color="deep-purple accent-4"-->
<!--                              size="40"-->
<!--                      >-->
<!--                          <v-icon-->
<!--                                  color="white"-->
<!--                          >-->
<!--                              mdi-card-account-details-->
<!--                          </v-icon>-->
<!--                      </v-avatar>-->

<!--                      <p class="text-subtitle-1">Become a member to get lots of benefits</p>-->

<!--                      <template v-slot:actions>-->
<!--                          <v-btn tile dark color="deep-purple accent-4" class="small">Read more</v-btn>-->
<!--                      </template>-->
<!--                  </v-banner>-->
<!--              </v-expand-transition>-->
              <h1 class="md-display-2 white--text mb-6">{{ $t('headings.Shop') }}</h1>
              <v-row v-if="!authenticated || (authenticated && !user.bundle_claimed_at && !hasActiveTrial && !user.membership)">
                  <v-col cols="12">
                      <v-card
                              class="mx-auto product-card"
                              outlined
                              :elevation="hover ? 4 : 0"
                      >
                          <v-card-text>
                              <v-row>
                                  <v-col class="col-12 col-md-6">
                                      <h1 class="headline primary--text">{{ $t('headings.Get your subscription and claim your FREE bundle') }}</h1>
                                      <h2 class="text-subtitle-1 mt-3 mb-6">{{ $t("You must have an active subscription to receive alerts, purchase new products, or activate tags") }}.</h2>

                                    <IndividualsSummary/>

                                  </v-col>
                                  <v-col class="col-12 col-md-6 text-right">
                                      <v-img v-if="brand === 'neotag'" contain class="mt-4 mr-6"
                                             src="https://findmykit-images.s3-eu-west-1.amazonaws.com/neotag-bundle.png"></v-img>
                                      <v-img v-else contain class="mt-4 mr-6"
                                             src="https://findmykit-images.s3-eu-west-1.amazonaws.com/personal-bundle.png"></v-img>
                                  </v-col>
                              </v-row>
                          </v-card-text>





                          <v-card-actions>
                                <v-btn v-if="authenticated && !!user.stripe_subscription === false" x-large elevation="0" color="primary" @click="membershipDialog = true">{{ $t('buttons.Subscribe now') }}</v-btn>
                                <v-btn v-if="authenticated && !user.bundle_claimed_at" x-large elevation="0" dark color="green" @click="navigate('basket')">{{ $t('buttons.Claim free bundle now') }}</v-btn>
                                <v-btn v-if="!authenticated" elevation="0" color="primary" @click="navigate('sign-up-individual')">{{ $t('buttons.Sign up as individual') }}</v-btn>
                              <v-btn v-if="!authenticated" elevation="0" color="primary" @click="navigate('login')">{{ $t('buttons.Login to add subscription') }}</v-btn>
                          </v-card-actions>


                      </v-card>
                  </v-col>
              </v-row>
              <v-row v-if="show">
                  <v-col
                          v-for="product in products"
                          :key="'product-' + product.id"
                          cols="12"
                          sm="6"
                          md="4"
                  >
                      <v-hover>
                          <template v-slot="{ hover }">
                              <v-card
                                      class="mx-auto product-card"
                                      outlined
                                      :elevation="hover ? 4 : 0"
                              >
                                  <v-card-title class="headline primary--text">{{product.name}}</v-card-title>

                                  <div v-if="product.product_images.length > 0" class="white">
                                    <v-img

                                        class="white--text align-end"
                                        height="300px"
                                        :src="product.product_images[0].path"
                                    >
                                      <v-overlay
                                          v-if="product.coming_soon"
                                          :absolute="true"
                                          :value="true"
                                          :opacity="0.5"
                                      >
                                        <p class="title white--text"><v-icon left large dark color="white">mdi-bullhorn</v-icon> {{ $t("Coming soon") }}</p>
                                      </v-overlay>
                                    </v-img>
                                  </div>

                                  <v-card
                                          v-else
                                          :color="`grey lighten-4`"
                                          class="px-3 pt-3 pb-3"
                                          flat
                                          tile
                                  >
                                      <v-skeleton-loader
                                              class="mx-auto"
                                              height="276"
                                              type="image"
                                      ></v-skeleton-loader>
                                      <v-overlay
                                              :absolute="true"
                                              :value="true"
                                              :opacity="0"
                                      >
                                          <p class="title black--text"><v-icon left large color="black">mdi-bullhorn</v-icon> {{ $t("Image coming soon") }}</p>
                                      </v-overlay>
                                  </v-card>

                                  <v-card-text class="text--primary">

                                      <p class="font-weight-black subtitle-1" v-if="product.enabled">{{ brand === 'neotag' ? '€' : '£'}}{{product.price}}</p>

                                      <div class="body-1">{{truncate(product.description, 100)}}</div>

                                      <p class="text-right mt-2">
                                          <router-link
                                                  :to="{ name: 'product', params: {slug: product.slug} }"
                                          >{{ $t('links.Read more') }}</router-link>
                                      </p>

                                      <p class="mt-6" v-if="product.personalisable">{{ $t("Personalised products will be posted separately within 6/8 weeks") }}.</p>

                                      <p class="mt-6" v-if="product.id === 3 || product.id === 4">{{ $t("Available for dispatch immediately") }}.</p>

                                  </v-card-text>

                                  <v-card-actions class="d-flex justify-space-between align-end" style="width: 100%">
                                      <v-btn v-if="product.coming_soon" disabled class="small" elevation="0" tile color="primary" @click="addToBasket(product)">
                                          <v-icon left>add_shopping_cart</v-icon> {{ $t("Coming soon") }}
                                      </v-btn>
                                      <v-btn v-else class="small" elevation="0" tile color="primary" @click="addToBasket(product)">
                                          <v-icon left>add_shopping_cart</v-icon> {{ $t('buttons.Add to basket') }}
                                      </v-btn>
                                      <v-img
                                              v-if="product.activate == 1"
                                              class="white--text"
                                              max-width="80px"
                                              :src="activ8Logo"
                                              eager
                                      >
                                      </v-img>
                                  </v-card-actions>
                              </v-card>
                          </template>
                      </v-hover>
                  </v-col>
              </v-row>
              <v-row v-else>
                  <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          v-for="item in 6"
                          v-bind:key="item"
                  >
                      <v-sheet
                              :color="`grey lighten-4`"
                              class="px-3 pt-3 pb-3"
                      >
                          <v-skeleton-loader
                                  class="mx-auto"
                                  max-width="300"
                                  type="card"
                          ></v-skeleton-loader>
                      </v-sheet>
                  </v-col>
              </v-row>

              <v-dialog
                      v-model="membershipDialog"
                      max-width="600"
              >
                  <v-card>
                      <v-card-title class="headline primary">
                          {{ $t('headings.Subscription') }}
                      </v-card-title>

                      <v-card-text>
                          <MembershipForm v-on:close-form="closeForm"/>
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                                  color="primary"
                                  text
                                  @click="membershipDialog = false"
                          >
                              {{ $t('buttons.Close') }}
                          </v-btn>
                      </v-card-actions>
                  </v-card>

              </v-dialog>

          </v-container>
      </v-container>
      <Footer />
  </div>

</template>

<script>

    import IndividualsSummary from "./IndividualsSummary";
    let product1 = require('@/assets/IMG_3382.jpg')

    import axios from 'axios';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import Footer from './Footer'
    import MembershipForm from './MembershipForm'
    import {i18n} from "../i18n";

    export default {
        name: 'Shop',
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Shop'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('Shop for personalised iron on or sticker tags to find your lost property') + '.' + i18n.t('Bag tags, Recovery card, Luggage insert, Key tags Golf bag tags, business card') }
            ]
          }
        },
        components: {
          IndividualsSummary,
            'Footer': Footer,
            'MembershipForm': MembershipForm
        },
        // props: {
        //   title: String
        // },
        data () {
            return {
                placeholder: product1,
                products: [],
                show: false,
                hover: false,
                expand: false,
                membershipDialog: false,
                reveal: false,
            }
        },
        mounted () {

            this.$gtag.pageview({
                page_path: '/shop',
            })

            document.getElementById("scrolling-content").scrollTop = 0

            this.loadProducts()
        },
        watch: {
          locale (to, from){
            if (to !== from) {
              this.loadProducts()
            }
          }
        },
        methods: {
            ...mapActions('basket', ['add']),
            loadProducts() {
              this.show = false

              const instance = axios.create({
                baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                headers: {'Accept-Language': this.locale},
              });

              instance
                  .get('/api/products/enabled?brand=' + this.brand)
                  .then(response => {
                    this.products = response.data.data
                  })
                  .catch(error => {
                    console.log(error)
                  })
                  .finally(() => {
                    this.show = true
                    this.expand = true
                    window.prerenderReady = true;
                  })
            },
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            addToBasket(product) {
                if (this.hasMembership || this.hasActiveTrial) {
                    return this.add({product}).then(() => {
                        console.log('add')
                        this.$gtag.event('Add', {
                            'event_category': 'Shop',
                            'event_label': 'Shop add',
                            'value': product.name
                        })
                    })
                }
                else {
                    //this.$router.push({name: 'membership'})
                    this.membershipDialog = true
                }
            },
            navigate(route, params) {
                this.$router.push({name: route, params: params})
            },
            truncate (description, length) {
                if (description.length > length) {
                    return description.substring(0, length) + '...';
                } else {
                    return description;
                }
            },
            closeForm() {
                this.membershipDialog = false
            }
        },
        computed: {
            ...mapGetters('account', ['hasMembership', 'hasActiveTrial']),
            ...mapState({
                authenticated: state => state.authenticated,
                user: state => state.account.user,
                brand: state => state.brand,
                brandName: state => state.brandName,
                locale: state => state.locale
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            activ8Logo() {
              if (this.brand === 'neotag') {
                return require('@/assets/activ8-logo-alpha-dark.png')
              }
              return require('@/assets/activ8-logo.png')
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
      margin: 40px 0 0;
    }
    ul {
      list-style-type: none;
      padding: 0;
    }
    li {
      display: inline-block;
      margin: 0 10px;
    }
    a {
      color: #42b983;
    }
    .product-card {
        border-radius: 15px;
        border: none !important;
        height: 100%;
        padding-bottom: 60px;
    }
    .product-card .v-card__actions {
        padding-left: 15px;
        padding-bottom: 15px;
        position: absolute;
        bottom: 0;
    }
    .product-card .headline {
        font-size: 1.4rem !important;
    }

    .title-back {
        background-color:rgba(0,0,0,0.4)
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .8s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
</style>
